export default __webpack_public_path__ + "static/media/goblin.f60cb7da.png";